import { __spreadArray } from "tslib";
var FolderNameValidationResult;
(function (FolderNameValidationResult) {
    FolderNameValidationResult["Good"] = "good";
    FolderNameValidationResult["Empty"] = "empty";
    FolderNameValidationResult["TooLong"] = "long";
    FolderNameValidationResult["InvalidCharacters"] = "invalid";
    FolderNameValidationResult["Blacklisted"] = "blacklist";
})(FolderNameValidationResult || (FolderNameValidationResult = {}));
export var MAX_TITLE_LENGTH = 50;
// the following is based on the backend logic, we should try to keep
// it in sync
function isValidFolderName(input, blacklistedNames) {
    if (blacklistedNames === void 0) { blacklistedNames = []; }
    var name = input.trim();
    if (!name || !name.length) {
        return FolderNameValidationResult.Empty;
    }
    if (name.length > MAX_TITLE_LENGTH) {
        return FolderNameValidationResult.TooLong;
    }
    if (!/^[ \w$?:.,'"\-+]+$/.test(name)) {
        return FolderNameValidationResult.InvalidCharacters;
    }
    if (__spreadArray([
        'favourites',
        'featured'
    ], blacklistedNames.map(function (n) { return n.toLowerCase(); }), true).includes(name.toLowerCase())) {
        return FolderNameValidationResult.Blacklisted;
    }
    return FolderNameValidationResult.Good;
}
export function getFolderNameValidationErrorMessage(name, t, blacklistedNames, isGallery) {
    if (blacklistedNames === void 0) { blacklistedNames = []; }
    var result = isValidFolderName(name, blacklistedNames);
    switch (result) {
        case FolderNameValidationResult.Empty:
            return t('collectionPanel.error.emptyName');
        case FolderNameValidationResult.TooLong:
            return t('collectionPanel.error.longName');
        case FolderNameValidationResult.InvalidCharacters:
            return t('collectionPanel.error.invalidCharacters');
        case FolderNameValidationResult.Blacklisted:
            if (isGallery) {
                return t('collectionPanel.error.blacklisted.gallery', { name: name });
            }
            return t('collectionPanel.error.blacklisted.collection', { name: name });
        default:
            return;
    }
}
//# sourceMappingURL=isValidFolderName.js.map